module.exports = __webpack_public_path__ + "img/active-repayments-icon.a9040163.svg";